module.exports = __webpack_public_path__ + "static/img/EP202504081424410.9dd8b9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/detail/EP202504081424410.jpg
// module id = S9ma
// module chunks = 1